import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/brand/cdlp/NeueHaasUnicaPro-Regular.otf%22,%22weight%22:%22400%22}],%22variable%22:%22--brand-font%22}],%22variableName%22:%22neueHaasUnicaFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'neueHaasUnicaFont', 'neueHaasUnicaFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
